module.exports = __webpack_public_path__ + "img/世界各国使用电压.31e09bd8.png";